"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurstAbilityHandler = exports.BurstActorAbilityFactory = exports.BurstAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class BurstAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Burst;
        this.__typeName = "Burst";
    }
}
exports.BurstAbilityArgs = BurstAbilityArgs;
let BurstActorAbilityFactory = class BurstActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Burst", "AllEnemies", 2);
    }
};
BurstActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Burst")
], BurstActorAbilityFactory);
exports.BurstActorAbilityFactory = BurstActorAbilityFactory;
let BurstAbilityHandler = class BurstAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            attackType: "melee",
            abilityKey: ability.args.__typeName,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map((targetId) => ({
                jitter: 0,
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 50)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Turns(5),
                        effect: new core_1.VulnerabilityEffectArgs(3)
                    }
                ],
            })),
            sequence,
        });
    }
};
BurstAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Burst)
], BurstAbilityHandler);
exports.BurstAbilityHandler = BurstAbilityHandler;
